export default __webpack_public_path__ + "static/media/Harry's Wand - Img - Final (2)_02.8995c1bc.jpg";